/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const NatObj = require('../types/NatObj')
const InfoLieu = require('../types/InfoLieu')
const InfoLigneLieu = require('../types/InfoLigneLieu')
const kernel = require('../kernel/kernel')
const CElementLigne = require('./CElementLigne')
const CSousListeObjets = require('./CSousListeObjets')
module.exports = CLieuDeBase

/**
 * Classe ancêtre de tous les lieux de points reliés.
 * @constructor
 * @extends CElementLigne
 * @param {CListeObjets} listeProprietaire : la liste propriétaire.
 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
 * @param {Booelan} estElementFinal : true si élément final de construction.
 * @param {mtg32.Couleur} couleur : La couleur de l'objet
 * @param {Booelan} masque : true si l'objet est masqué
 * @param {mtg32.StyleTrait} style : le style de tracé.
 * @param {CPt} pointATracer : Le point qui laisse une trace.
 * @param {InfoLieu} infoLieu
 * @returns {CLieuDeBase}
 */
function CLieuDeBase (listeProprietaire, impProto, estElementFinal, couleur, masque, style, pointATracer, infoLieu) {
  if (arguments.length !== 0) {
    if (arguments.length === 1) CElementLigne.call(this, listeProprietaire);
    else {
      CElementLigne.call(this, listeProprietaire, impProto, estElementFinal, couleur,
        true, 0, 0, masque, "", 16, style);
      this.pointATracer = pointATracer;
      this.infoLieu = infoLieu;
      this.abscissesCoordonneesPoints = new Array(infoLieu.nombreDePoints + 1);
      this.ordonneesCoordonneesPoints = new Array(infoLieu.nombreDePoints + 1);
      var nb = Math.floor(this.infoLieu.nombreDePoints/2)+2;
      this.infoLignes = new Array(nb);
      // Il faut initialiser chaque élément du tableau
      for (var i = 0; i < nb; i++) {
        this.infoLignes[i] = new InfoLigneLieu();
      }
      // Il faut créer la liste des éléments dont dépend le point à tracer
      this.listeElementsAncetres = new CSousListeObjets();
    }
  }
}
CLieuDeBase.prototype = new CElementLigne();
CLieuDeBase.prototype.constructor = CLieuDeBase;
CLieuDeBase.prototype.superClass = "CElementLigne";
CLieuDeBase.prototype.className = "CLieuDeBase";

CLieuDeBase.prototype.setClone = function(ptel) {
  CElementLigne.prototype.setClone.call(this, ptel);
  this.nombreLignes = ptel.nombreLignes;
  this.infoLieu.setCopy(ptel.infoLieu); // Il faut copier toutes les coordonnées
  for (var j = 0; j < this.nombreLignes; j++) {
    this.infoLignes[j].setCopy(ptel.infoLignes[j]);
    for (var k = 0; k < this.infoLignes[j].nombrePoints; k++) {
      this.abscissesCoordonneesPoints[this.infoLignes[j].indicePremierPoint+k] =
        ptel.abscissesCoordonneesPoints[this.infoLignes[j].indicePremierPoint+k];
      this.ordonneesCoordonneesPoints[this.infoLignes[j].indicePremierPoint+k] =
        ptel.ordonneesCoordonneesPoints[this.infoLignes[j].indicePremierPoint+k];
    }
  }
};
CLieuDeBase.prototype.dependDe = function(p) {
  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
  return this.memoriseDependance(CElementLigne.prototype.dependDe.call(this, p) || this.pointATracer.dependDe(p));
};
CLieuDeBase.prototype.dependDePourBoucle = function(p) {
  return (p === this) || this.pointATracer.dependDePourBoucle(p);
};
// Spécifique JavaScript
CLieuDeBase.prototype.createg = function() {
  var j,nombrePoints,indPremPoint,j,k,k1;
  var style = "";
  var styleRect;
  var stroke = this.style.stroke;
  if (stroke.length !== 0) style += "stroke-dasharray:"+stroke+";";
  var strokewidth = this.style.strokeWidth;
  // var coul = this.couleur.rgb(); // Modifié version 4.9.9.4
  var coul = this.color;
  style += "stroke-width:"+strokewidth+";";
  style += "stroke:"+coul+";";
  styleRect = style;
  style += "fill:none";
  styleRect += "fill:"+coul;
  var g = kernel.cens("g");
  // g.setAttribute("style", style); // Supprimé version mtgApp. Inutile

  for (j = 0; j < this.nombreLignes; j++) {
    nombrePoints = this.infoLignes[j].nombrePoints;
    // Optimisé version 3.9 On trace maintenant les points isolés du lieu
    indPremPoint = this.infoLignes[j].indicePremierPoint;
    if (nombrePoints === 1) {
      var r = kernel.cens("rect",{
        x : this.abscissesCoordonneesPoints[indPremPoint],
        y : this.ordonneesCoordonneesPoints[indPremPoint],
        width : "1",
        height : "1",
        style :styleRect
      });
      g.appendChild(r);
    }
    else {
      // Il faut transférer les coordonnées de chaque ligne pour pouvoir la tracer en java
      var points = "";
      for (k = 0; k < nombrePoints; k++) {
        k1 = indPremPoint + k;
        points = points + this.abscissesCoordonneesPoints[k1] + ",";
        points = points + this.ordonneesCoordonneesPoints[k1] + " ";
      }
      var pol = kernel.cens("polyline",{
        style : style,
        points : points
      });
      g.appendChild(pol);
    }
  }
  g.setAttribute("pointer-events", "none");
  return g;
};
CLieuDeBase.prototype.trace = function(svg, couleurFond, transparence) {
  var g = this.createg();
  g.setAttribute("id",this.id);
  svg.appendChild(g);
  this.g = g;
};
CLieuDeBase.prototype.update = function(svg) {
  var oldg = this.g;
  var g = this.createg();
  svg.replaceChild(g, oldg);
  g.setAttribute("id",this.id);
  this.g = g;
};
/**
 * Renvoie true si le lieu de points n'est formé que d'une seule ligne.
 * @returns {Boolean}
 */
CLieuDeBase.prototype.contientUneSeuleLigne = function() {
  return (this.nombreLignesDePlusieursPoints === 1);
};
/**
 * Renvoie true si le lieu contient au moins une ligne.
 * @returns {Boolean}
 */
CLieuDeBase.prototype.contientAuMoinsUneLigne = function() {
  return (this.nombreLignesDePlusieursPoints >= 1);
};
CLieuDeBase.prototype.remplacePoint = function(ancienPoint, nouveauPoint) {
  if (this.pointATracer=== ancienPoint) this.pointATracer = nouveauPoint;
};
CLieuDeBase.prototype.getNature = function() {
  return NatObj.NLieu;
};
CLieuDeBase.prototype.dansFen = function(dimfen) {
  if (!this.existe) return false;
  var resultat = false;
  for (var j = 0; (j < this.nombreLignes) && !resultat; j++)
  {
    for (var k = this.infoLignes[j].indicePremierPoint; k <= this.infoLignes[j].indicePremierPoint +
        this.infoLignes[j].nombrePoints-2;k++) {
      resultat = resultat || dimfen.dansFenetre(this.abscissesCoordonneesPoints[k],this.ordonneesCoordonneesPoints[k]);
    }
  }
  return resultat;
};
CLieuDeBase.prototype.chaineDesignation = function() {
  return "desLieuPoint";
};
CLieuDeBase.prototype.read = function(inps, list){
  CElementLigne.prototype.read.call(this, inps, list);
  var ind1 = inps.readInt();
  this.pointATracer = list.get(ind1,"CPt");
  this.infoLieu = new InfoLieu();
  this.infoLieu.read(inps);
  // Il faut créer les tableaux de coordonnées
  // On réserve une coordonnée supplémentaire pour le cas d'un lieu fermé
  this.abscissesCoordonneesPoints = new Array(this.infoLieu.nombreDePoints + 1);
  this.ordonneesCoordonneesPoints = new Array(this.infoLieu.nombreDePoints + 1);
  var nb = this.infoLieu.nombreDePoints/2+2;
  this.infoLignes = new Array(nb);
  // Il faut initialiser chaque élément du tableau
  for (var i = 0; i < nb; i++) this.infoLignes[i] = new InfoLigneLieu();
  // Il faut créer la liste des éléments dont dépend le point à tracer
  this.listeElementsAncetres = new CSousListeObjets();
};
CLieuDeBase.prototype.write = function(oups, list){
  CElementLigne.prototype.write.call(this, oups, list);
  var ind1 = list.indexOf(this.pointATracer);
  oups.writeInt(ind1);
  this.infoLieu.write(oups,list);
};



// WEBPACK FOOTER //
// ./src/objets/CLieuDeBase.js